export default __webpack_public_path__ + "static/media/shop_1.84385e1c.png";